 export class tblstudent{

    public ID:number
    public FIRSTNAME:string
    public LASTNAME:string
    public ROLLNO:number
    public AGE:number
}